export const editName = "block-property" as const;
export const renderName = "Block-property" as const;
